import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    return Promise.reject(err);
  }
);

export default api;

// Helper: file download URL that works in <img>/<iframe> (uses ?auth= query param would need JWT; simpler use blob fetch)
export const fileBlobUrl = async (fileId) => {
  const res = await api.get(`/files/${fileId}/download`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
